module.exports= {
  backendeleres:  process.env.NODE_ENV === 'production' ? "/" : "http://localhost:15625/"
}
